import {EventEmitter} from 'fbemitter'
const UiEmitter = new EventEmitter()
export default UiEmitter



// WEBPACK FOOTER //
// ./src/lib/UiEmitter.js